<template>
  <div class='app-container'>

    <icare-table
      ref='table'
      searchTip='请根据设备编号进行搜索'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='paginationConfig'
      methods-data='other_report'
      params>
      <div>
        <span class='left-table'>机柜编号：</span>
        <el-input v-model='cabinet_id' placeholder='请输入机柜编号' style='width: 200px;' clearable></el-input>
        <span class='left-table'>时间范围：</span>
        <el-date-picker
          v-model='findDateTime'
          :picker-options='pickerOptions'
          type='datetimerange'
          align='right'
          start-placeholder='开始'
          end-placeholder='结止'
          format='yyyy-MM-dd HH:mm:ss'
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>

        <span class='left-table'>
          订单类型：
          <el-select v-model='device_type' placeholder='请选择' @change='deviceTypeSelect'>
            <el-option
              v-for='item in deviceTypeList'
              :key='item.value'
              :label='item.label'
              :value='item.value'
            ></el-option>
          </el-select>
        </span>
        <span class='left-table'>
          <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
        </span>
        <span class='left-table'>
          <el-button icon='el-icon-download' @click='down'>下载报表</el-button>
        </span>


        <div style='float: right;margin-right: 10%;margin-top: 10px;'>
            <span
              style='margin-left: 50px;font-size: 16px;font-weight: 600;color: #42b983;'>收入总额：{{ (sum_data.sum_amount / 100).toFixed(2)
              }} 元</span>
          <span
            style='margin-left: 50px;font-size: 16px;font-weight: 600;color: #F56C6C;'>退款总额：{{ (sum_data.sum_refund_fee / 100).toFixed(2)
            }}元</span>
        </div>

      </div>
    </icare-table>
  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'
import { xlsx } from '@/utils/xlsx'

export default {
  name: 'get_refund_order',
  data() {
    return {
      sum_data: {},
      paginationConfig: {
        cabinet_id: null,
        start_time: '',
        end_time: ''
      },
      // 日期时间范围在一个月以内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime()
          if (maxDate) {
            this.selectDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 31 * 24 * 3600 * 1000
            const minTime = this.selectDate - one
            const maxTime = this.selectDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      findDateTime: [],
      deviceTypeList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '0',
          label: '充电仓位'
        },
        {
          value: '1',
          label: '充电插座'
        }
      ],
      cabinet_id: '',
      device_type: '',
      titleConfig: [
        {
          field: 'cabinet_id',
          title: '机柜编号',
          visible: true,
          fuc: function(title, item, row) {
            return row.cabinet_id
          }
        },
        {
          field: 'create_time',
          title: '交易时间',
          visible: true,
          fuc: function(title, item, row) {
            return row.create_time
          }
        },
        {
          field: 'id',
          title: '商户订单号',
          visible: true
        },
        {
          field: 'platform_trade_code',
          title: '微信订单号',
          visible: true
        },
        {
          field: 'device_type',
          title: '订单类型',
          visible: true,
          fuc: val => {
            let v
            if (val == 1) {
              v = '<div >充电插座</div>'
            } else {
              v = '<div >充电仓位</div>'
            }
            return v
          }
        },
        {
          field: 'total',
          title: '订单金额(元)',
          visible: true,
          fuc: val => {
            return val == 0 ? '0.00' : (val / 100).toFixed(2) + ''
          }
        },
        {
          field: 'cash',
          title: '支付金额(元)',
          visible: true,
          fuc: val => {
            return val == 0 ? '<div>0.00</div>' : '<div style="color: #67C23A">+' + (val / 100).toFixed(2) + '</div>'
          }
        },
        {
          field: 'coupon',
          title: '代金券金额(元)',
          visible: true,
          fuc: val => {
            return val == 0 ? '<div >0.00</div>' : '<div style="color: #F56C6C">-' + (val / 100).toFixed(2) + '</div>'
          }
        },
        {
          field: 'refund_fee',
          title: '退款金额(元)',
          visible: true,
          fuc: val => {
            return val == 0 ? '<div>0.00</div>' : '<div style="color: #F56C6C">-' + (val / 100).toFixed(2) + '</div>'
          }
        },
        {
          field: 'amount',
          title: '实际收入(元)',
          visible: true,
          fuc: val => {
            return val == 0 ? '<div>0.00</div>' : '<div style="color: #409EFF">' + (val / 100).toFixed(2) + '</div>'
          }
        }
      ]
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    //this.findDateTime=this.getPastTime()
    this.paginationConfig.req_type = 'get_trade_bill_list'
    this.getTradeBillSum()
  },
  mounted() {
  },
  methods: {
    find() {
      this.paginationConfig.cabinet_id = parseInt(this.cabinet_id)
      if (this.findDateTime != null && this.findDateTime.length === 2) {
        this.paginationConfig.start_time = this.findDateTime[0]
        this.paginationConfig.end_time = this.findDateTime[1]
      } else {
        this.paginationConfig.start_time = ''
        this.paginationConfig.end_time = ''
      }
      this.$refs.table.refresh()
      this.getTradeBillSum()
    },
    deviceTypeSelect(v) {
      this.paginationConfig.device_type = v
    },
    down() {
      if (this.findDateTime == null || this.findDateTime.length !== 2) {
        this.$message.warning('所选时间范围不能大于31天')
        return
      }
      if (this.date_type == 'day') { //判断是否是一个月的数据
        var startDate = new Date(this.findDateTime[0]).getTime()
        var endDate = new Date(this.findDateTime[1]).getTime()
        if (endDate - startDate > 31 * 24 * 60 * 60 * 1000) {
          this.$message({
            message: '所选时间范围不能大于31天',
            type: 'warning'
          })
          return
        }
      }
      this.find()
      //this.$message.warning('敬请期待')
      let str = JSON.stringify({
        cabinet_id:parseInt( this.cabinet_id),
        start_time:this.findDateTime[0],
        end_time: this.findDateTime[1],
        req_type: 'down_trade_bill_list',
        device_type: this.device_type
      })
      gateway({
        func: 'other_report',
        params: str
      }).then(res => {
        if (res.code == 0) {
          var time = new Date().getTime()
          var header = {
            cabinet_id: '机柜编号',
            create_time: '交易时间',
            id: '商户订单号',
            platform_trade_code: '微信订单号',
            device_type: '订单类型',
            total: '订单金额(元)',
            cash: '支付金额(元)',
            coupon: '代金券金额(元)',
            refund_fee: '退款金额(元)',
            amount: '实际收入(元)'
          }
          for (var i = 0; i < res.result.length; i++) {
            res.result[i].cabinet_id = (res.result[i].cabinet_id == 0 ? '所有机柜' : res.result[i].cabinet_id )
            res.result[i].device_type = (this.device_type=='' ? '所有订单': res.result[i].device_type == 0 ? '充电仓位' : '充电插座')
            res.result[i].total = ((res.result[i].total / 100).toFixed(2))
            res.result[i].cash = ((res.result[i].cash / 100).toFixed(2))
            res.result[i].coupon = ((res.result[i].coupon / 100).toFixed(2))
            res.result[i].refund_fee = ((res.result[i].refund_fee / 100).toFixed(2))
            res.result[i].amount = ((res.result[i].amount / 100).toFixed(2))
          }
          xlsx(res.result, header, (this.cabinet_id==0 ? '所有机柜':this.cabinet_id)+'-交易账单-' + time)
        }
      })
    },


    getTradeBillSum() {
      let str = JSON.stringify({
        cabinet_id: this.paginationConfig.cabinet_id,
        start_time: this.paginationConfig.start_time,
        end_time: this.paginationConfig.end_time,
        req_type: 'get_trade_bill_sum',
        device_type: this.paginationConfig.device_type
      })
      gateway({
        func: 'other_report',
        params: str
      }).then(res => {
        if (res.code == 0) {
          this.sum_data = res.result
        }
      })
    },
    // 获取过去几个月的时间
    getPastTime() {
      // 获取本月时间段datePicker使用
      const oDate = new Date()
      let year = oDate.getFullYear()
      let month = oDate.getMonth()
      let start, end
      if (month == 0) {
        year--
        start = new Date(year, 0, 1)
        end = new Date(year, 12, 31)
      } else {
        start = new Date(year, month, 1)
        end = new Date(year, month + 1, 0, 23, 59, 59)
      }
      return [start, end]
    }
  }
}
</script>

<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}
</style>
